<main class="min-h-screen bg-bg-base flex flex-col">
  <app-about-header></app-about-header>
  <div class="flex-1">
    <app-about-statistics></app-about-statistics>
    <app-about-our-story></app-about-our-story>
    <app-about-our-mission></app-about-our-mission>
    <app-about-our-values></app-about-our-values>
    <app-home-why-stay-at></app-home-why-stay-at>
<app-home-who-are-you></app-home-who-are-you>

    <app-about-our-team></app-about-our-team>
    <app-contact-us></app-contact-us>
  </div>
</main>